import BaseModelFMVStatementReport from "@/models/BaseModelFMVStatementReport.js";
export const FMVSEntryConfig = {
	grid: {
		gridId: 'FMVSEntryGrid',
		height: 500,
		checkbox: true,
		edit: false,
		delete: false,
		pageSize: 100,
		groupable: true,
		pdfdoc: true
	},
	columns: BaseModelFMVStatementReport.columns,
	list: BaseModelFMVStatementReport.list
}

export const ToolbarConfig = {
	list: 'ToolBarItems',
	items: [{
			template: `<Label style="width:110px;">Select Period: </Label>
            <div id="kendo-select"><input id="dropdownPeriodFMVStatement" style="width:120px;" /></div>`,
			overflow: "never"

			// template: `<Label style="width:200px;">Select Period: </Label>
			// <select id="dropdownPeriodFMVStatement" class="form-control">
			// </select>`,        
		},
		{
			id: "btnIndividualByTaxId",
			type: "button",
			text: "Individual Report By TaxId",
			showIcon: "toolbar",
			icon: "file-ascx",
			attributes: {
				"class": "float-right-btn btn btn-primary"
			},
		},
		{
			id: "btnIndividual",
			type: "button",
			text: "Individual Report",
			showIcon: "toolbar",
			icon: "file-ascx",
			attributes: {
				"class": "float-right-btn btn btn-primary"
			},
		}, 
		{
			id: "btnBulk",
			type: "button",
			text: "Bulk Processing",
			icon: "aggregate-fields",
			showIcon: "toolbar",
			attributes: {
				"class": "float-right-btn btn btn-secondary"
			},
		},
		{
			id: "btnBulkByTaxId",
			type: "button",
			text: "Bulk Processing By TaxId",
			icon: "aggregate-fields",
			showIcon: "toolbar",
			attributes: {
				"class": "float-right-btn btn btn-secondary"
			},
		},	
		{
			id: "btnDownload",
			type: "button",
			text: "Download Zip",
			showIcon: "toolbar",
			icon: "download",
			attributes: {
				"class": "float-right-btn btn btn-tertiary"
			},
		},

	]
}